import {useMemo, useState} from "react";
import type {I18nKey} from "@corporatesclub/shared";
import {getPasswordStrength} from "@/lib/passwordStrength";
import {useI18n} from "./I18nProvider";

const STRENGTH_LABEL: Record<number, I18nKey> = {
  0: "Weak password",
  1: "Fair password",
  2: "Good password",
  3: "Strong password",
  4: "Strong password"
};

type Props = {
  name?: string;
  value: string;
  onChange: (v: string) => void;
  placeholder?: string;
  showStrength?: boolean;
  inputClassName?: string;
};

export function PasswordField({name, value, onChange, placeholder, showStrength = false, inputClassName = "cc-account__input"}: Props) {
  const {t} = useI18n();
  const [visible, setVisible] = useState(false);
  const strength = useMemo(() => getPasswordStrength(value), [value]);
  return (
    <div className="cc-account__passWrap">
      <div className="cc-account__passInputRow">
        <input
          type={visible ? "text" : "password"}
          name={name}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          className={inputClassName}
          autoComplete="new-password"
          aria-required="true"
        />
        <button
          type="button"
          className="cc-account__passToggle anim"
          onClick={() => setVisible(!visible)}
          aria-label={visible ? t("Hide password") : t("Show password")}
        >
          <i className={`fa ${visible ? "fa-eye-slash" : "fa-eye"}`} aria-hidden="true" />
        </button>
      </div>
      {showStrength && value ? (
        <div className="cc-account__passStrength" aria-live="polite">
          <div className="cc-account__passStrengthBar">
            <span className={`cc-account__passStrengthFill cc-account__passStrengthFill--${strength.score}`} style={{width: `${(strength.score + 1) * 20}%`}} />
          </div>
          <span className={`cc-account__passStrengthLbl cc-account__passStrengthLbl--${strength.score}`}>{t(STRENGTH_LABEL[strength.score])}</span>
        </div>
      ) : null}
    </div>
  );
}
